import adminApi from './api';

/** 资源转移（管理端 /api/admin/transfers*）。 */
const call = async (p) => {
    try {
        const res = await p;
        return res.data?.data;
    } catch (e) {
        throw e.response?.data || e;
    }
};

const transferAdminService = {
    logs: (params) => call(adminApi.get('/transfers/logs', { params })),
    requests: (params) => call(adminApi.get('/transfers', { params })),
    preview: (type, id, toUser) => call(adminApi.post('/transfers/preview', { type, id, to_user: toUser })),
    transfer: (type, id, toUser, reason) => call(adminApi.post('/transfers', { type, id, to_user: toUser, reason })),
};

export const TRANSFER_TYPE_LABELS = {
    evm: '云服务器', domain: '域名', cdn: 'CDN 域名', dns: 'DNS 区域', host_shared: '共享主机', host: '独享容器（旧版）', container: '独享容器',
};

export default transferAdminService;
